import type { ProductInfoBoxFeatureConfig } from '../../types/features/ProductInfoBoxFeatureConfig';

export const productInfoBox: ProductInfoBoxFeatureConfig = {
    showContractNumber: false,
    showCurrentInstallment: true,
    showPurchasePrice: false,
    showRemainingTerm: true,
};
